import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input } from 'antd';

import get from 'lodash/get';
import { permissionService } from 'shared/services';

import './PartnerDetail.style.less';

const { checkPermission } = permissionService;

class PartnerDetailTnCForm extends Component {
  _handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this.onValidate);
  };

  onValidate = (err, values) => {
    const { onValidateSuccess } = this.props;
    if (!err) {
      const payload = {
        tnc: {
          en: values.tncEn,
          id: values.tncId,
        },
      };

      if (onValidateSuccess) {
        onValidateSuccess(payload);
      }
    }
  };

  _renderBtn = () => {
    const canEditTnc = checkPermission('Partner Management:update', true);

    return (
      <div className="modal-tnc-btn">
        {canEditTnc && (
          <Button
            type="primary"
            className="btn"
            onClick={this._handleSubmit}
            loading={this.props.loading}
          >
            Update
          </Button>
        )}

        <Button type="default" className="btn" onClick={this.props.onBack}>
          Cancel
        </Button>

        <span className="mandatory">
          <i>(*) Mandatory Field</i>
        </span>
      </div>
    );
  };

  render() {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <div className="white-box-wrapper">
        <Form>
          <Form.Item label="EN" required colon={false}>
            {getFieldDecorator('tncEn', {
              initialValue: get(this.props.tnc, 'en'),
              rules: [
                {
                  required: true,
                  message: 'Please input EN TnC Content',
                },
              ],
            })(<Input.TextArea type="text" size="large" placeholder="EN" />)}
          </Form.Item>

          <Form.Item label="ID" required colon={false}>
            {getFieldDecorator('tncId', {
              initialValue: get(this.props.tnc, 'id'),
              rules: [
                {
                  required: true,
                  message: 'Please input ID TnC Content',
                },
              ],
            })(<Input.TextArea type="text" size="large" placeholder="ID" />)}
          </Form.Item>

          {this._renderBtn()}
        </Form>
      </div>
    );
  }
}

PartnerDetailTnCForm.propTypes = {
  form: PropTypes.object,
  onBack: PropTypes.func,
  tnc: PropTypes.object,
  onValidateSuccess: PropTypes.func,
  loading: PropTypes.bool,
};

export default PartnerDetailTnCForm;
